<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Student Ledger Details">
      <v-card-actions>
          <router-link :to="{ name: 'studentList' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>Back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
      </v-card-actions>
      <v-card-component>
        <v-row key="1">
          <v-col cols="12" md="2" lg="2" xl="2" align="center">
            <v-img :src="tots_image" width="120"> </v-img>
          </v-col>
          <v-col cols="6" md="2" lg="2" xl="2">
            <div class="d-flex justify-space-between caption ">
              <div>
                <div class="grey--text text-subtitle-2  mb-1">
                  Enquiry Code
                </div>
                <div class="text-button mb-1"
                v-text="studentInfo && studentInfo.enquiryCode ? studentInfo.enquiryCode : '-'">
                </div>
              </div>
            </div>
          </v-col>
          <v-col cols="6" md="2" lg="2" xl="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Name
                </div>
                <span
                  class="text-button mb-1" v-text="studentInfo && studentInfo.studentFirstName ? studentInfo.studentFirstName +' ' :' '"
                >
                </span>
                <span
                  class="text-button mb-1" v-text="studentInfo && studentInfo.studentLastName ? studentInfo.studentLastName : ' '"
                >
                </span>
              </div>
            </div>
          </v-col>
          <v-col cols="6" md="2" lg="2" xl="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Franchisee Name
                </div>
                <div class="text-button mb-1" v-text="studentInfo && studentInfo.franchisee && studentInfo.franchisee.companyName ? studentInfo.franchisee.companyName : '-'"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="6" md="2" lg="2" xl="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Academic Year
                </div>
                <div
                  class="text-button mb-1"
                  v-text="studentInfo && studentInfo.franchiseeAcademicYear && studentInfo.franchiseeAcademicYear.academicYear ? studentInfo.franchiseeAcademicYear.academicYear : '-'"
                ></div>
              </div>
            </div>
          </v-col>
          <v-col cols="6" md="2" lg="2" xl="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Class
                </div>
                <div class="text-button mb-1" v-text="studentInfo && studentInfo.studentClass && studentInfo.studentClass.name ? studentInfo.studentClass.name : '-'"></div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row key="2">
          <!-- <v-col cols="12" md="2" lg="2" xl="2" align="center"> </v-col> -->
          <v-col cols="6" md="2" lg="2" xl="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Name
                </div>
                <div class="text-button mb-1" v-text="studentInfo && studentInfo.fatherName ? studentInfo.fatherName : '-'"></div>
              </div>
            </div>
          </v-col>

          <v-col cols="6" md="4" lg="2" xl="4">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                 Parent / Guardian Mobile
                </div>
                <div class="text-button mb-1" v-text="studentInfo && studentInfo.fatherMobile ? studentInfo.fatherMobile : '-'"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="6" md="2" lg="2" xl="2">
            <div class="d-flex justify-space-between caption">
              <div>
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Gender
                </div>
                <div v-if="studentInfo.gender ==='Female' || studentInfo.gender ==='FEMALE'" class="text-button mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Female' ? 'Girl' : '-'||studentInfo && studentInfo.gender && studentInfo.gender ==='FEMALE' ? 'Girl' : '-'"></div>
                <div v-if="studentInfo.gender ==='Male' || studentInfo.gender ==='MALE'" class="text-button mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Male' ? 'Boy' : '-' || studentInfo && studentInfo.gender && studentInfo.gender ==='MALE' ? 'Boy' : '-'"></div>
                <div v-if="studentInfo.gender === null" class="mb-1">-</div>
                </div>
            </div>
          </v-col>
        </v-row>
      </v-card-component>
      <v-row key="3">
        <v-col cols="12">
          <template>
            <v-row>
              <v-col cols="12" lg="12" sm="12">
<v-card-component>                <v-data-table outlined :headers="headers" :items="feeTypeGroup" sort-by hide-default-footer :items-per-page="-1" item-key="feeTypeName">
                  <template v-slot:top>
                    <v-toolbar flat color="white">
                      <v-toolbar-title>Transaction Details</v-toolbar-title>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.creditAmount='{item}'>
                    <span v-if="item.transactionType==='Dr'">{{item.amount}}</span>
                    </template>
                    <template v-slot:item.debitAmount='{item}'>
                    <span v-if="item.transactionType==='Cr'">{{item.amount}}</span>
                    </template>
                    <template v-slot:body.append>
                      <tr>
                         <th ></th>
                          <th ></th>
                           <th ></th>
                            <th class="text-right text-subtitle-2">Total</th>
                             <th class="text-center text-subtitle-2">{{total}}</th>
                               <th ></th>

                        <!-- <th class="text-center text-subtitle-2">{{ totalAmount.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isConcession">{{ totalConcession.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ totalAmountDue.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isGST && isIGST">{{ totalIGST.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isGST && !isIGST">{{ totalCGST.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2" v-if="isGST && !isIGST">{{ totalSGST.toFixed(2) }}</th>
                        <th class="text-center text-subtitle-2">{{ Number(totalAmountToPay).toFixed(2) }}</th> -->
                      </tr>
                    </template>
                </v-data-table></v-card-component>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>

      <v-snackbar v-model="snackbar" :timeout="snackbarTimeout">
        {{ snackbarMsg || 'Welcome' }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </material-card>

  </v-container>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

// import ThankYou from '../../Fees/payment/thankYou'
// import ErrorPage from '../../Fees/payment/error'

export default {
  name: 'PlanAssignInstallmentList',
  components: { MaterialCard, VCardComponent },
  props: ['studentAdmissionID'],
  data () {
    return {

      disable: true,
      total: 0,
      dialog: false,
      snackbar: false,
      limitCallBack: 0,
      snackbarMsg: '',
      snackbarTimeout: 2000,
      headers: this.getHeaders(),
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      paginated: false,

      loadingComponent: null,

      feeTypeGroup: [],

      studentInfo: null
    }
  },
  async created () {
    await this.getAllInfo()
  },
  methods: {
    getHeaders () {
      let header = [
        { text: 'Date ', value: 'transactionDate', align: 'center' },
        { text: 'Payment ID ', value: 'referenceID', align: 'center' },
        { text: 'Type', value: 'transactionType', align: 'center' },
        { text: 'Particulars', value: 'transactionDescription', align: 'center' },
        { text: 'Credit ', value: 'creditAmount', align: 'center' },
        { text: 'Debit ', value: 'debitAmount', align: 'center' }

      ]
      // _.forEach(this.feeTypeGroup, obj => {
      //   if (obj.transactionType === 'Cr') {
      //     header.push({ text: 'Credit', value: 'amount', align: 'center' })
      //   }
      //   if (obj.transactionType === 'Dr') {
      //     header.push({ text: 'Debit', value: 'amount', align: 'center' })
      //   }
      // })

      return header
    },

    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(`${constants.API_URL}/api/student-payment/${this.studentAdmissionID}`)

        this.studentInfo = response.data.studentInfo
        this.feeTypeGroup = response.data.studentPaymentData
        response.data.studentPaymentData.map(obj => {
          obj.transactionDate = new Date(obj.transactionDate).toLocaleString()
          obj.transactionType = obj.transactionType === 'CREDIT' ? 'Dr' : 'Cr'
          obj.amount = Number(obj.amount)
        })
        this.total = _.sumBy(response.data.studentPaymentData, 'amount').toFixed(2)
        this.headers = this.getHeaders()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
table td,
table th {
  border-left: thin solid rgba(0, 0, 0, 0.12);
}
</style>

</style>
